import React, { FC } from 'react';
import { Alert } from '@kontentino/ui';
import { usePostQuery } from 'app/modules/posts/modules/post/hooks/usePostQuery';

type Props = {
  id: number;
};
const PostBeforeScheduleAlert: FC<Props> = ({ id }) => {
  const {
    postDetail: { data },
  } = usePostQuery(id);

  if (data?.scheduling_information?.chosen_method === 'export') {
    return (
      <Alert
        variant="danger"
        cta={{
          label: 'View post on Facebook',
          onClick: () =>
            window.open(data?.scheduling_information?.data ?? '', '_blank'),
          position: 'bottom',
        }}
      >
        This post is already scheduled on your Facebook page. Any changes you
        make here now will not be applied to the post on Facebook.
      </Alert>
    );
  }

  return null;
};

export default PostBeforeScheduleAlert;
